import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { ApplicationState } from '../../../../../store';
import { ICustomer } from '../../../../../store/ducks/customers/types';
import { loadLastOrders } from '../../../../../store/ducks/long-steel-order-item-search/actions';
import LastOrderList from '../LastOrderList';
import { Container } from './styles';
import MessageChooseItem from '../../../../../components/MessageChooseItem';
import { cleanShoppingCart } from '../../../../../store/ducks/long-steel-shopping-cart/actions';
import { BlockedModal } from '../../../../../components/Purchase/BlockedModal';

const RepeatOrder: React.FC = () => {
  const dispatch = useDispatch();

  const selectedCustomerId = useSelector(
    (state: ApplicationState) => state.longSteelShoppingCart.emitterId
  );
  const customers = useSelector((state: ApplicationState) => state.customers);
  const orderItemSearch = useSelector(
    (state: ApplicationState) => state.longSteelOrderItemSearch
  );
  const getCustomer = (): ICustomer => {
    return customers.customers.find(
      (customer) => customer.customerId === selectedCustomerId
    ) as ICustomer;
  };

  const selectedCustomer = getCustomer();
  const isBlockedCustomer =
    selectedCustomer?.blocks &&
    selectedCustomer?.blocks?.filter((blc) => blc.type === 'order')?.length > 0;
  const [openBlockedModal, setOpenBlockedModal] = useState(isBlockedCustomer);
  const onCloseBlockedModal = () => {
    dispatch(cleanShoppingCart());
    setOpenBlockedModal(false);
  };
  useEffect(() => {
    setOpenBlockedModal(isBlockedCustomer);
  }, [selectedCustomer]);

  useEffect(() => {
    if (
      selectedCustomerId !== '' &&
      !orderItemSearch.lastOrdersState.loading &&
      orderItemSearch.lastOrdersState.customerId !== selectedCustomerId
    ) {
      dispatch(loadLastOrders(selectedCustomerId));
    }
    localStorage.setItem('tipo_compra', 'compra_por_historico');
  });

  const MessageChooseProduct = ({ canShow = false }) => {
    if (!canShow) {
      return null;
    }

    return (
      <MessageChooseItem
        message="Escolha o emissor e o recebedor
        para ver seu histórico de pedidos."
      >
        {openBlockedModal && (
          <BlockedModal onCloseModal={onCloseBlockedModal} />
        )}
      </MessageChooseItem>
    );
  };

  return (
    <>
      <Container>
        <MessageChooseProduct
          canShow={
            isBlockedCustomer ||
            selectedCustomerId === '' ||
            orderItemSearch.lastOrdersState.lastOrders.length === 0
          }
        />

        <LastOrderList getCustomer={getCustomer} />
      </Container>
    </>
  );
};

export default RepeatOrder;
